import styled from 'styled-components'

export const GroupButtonContainer = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 4px;
  background: ${props => props.theme.colors.colore9ecf3};
  border: 1px solid ${props => props.theme.colors.colordfe3e8};
`

export const RadioInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const LabelButton = styled.label`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 0 12px;
  border: none;
  border-radius: 4px;
  background: transparent;
  user-select: none;
  cursor: pointer;
  border: 1px solid transparent;

  color: ${props => props.theme.colors.color6b7786};
  font-weight: 400;
  font-size: 12px;
  line-height: 30px;
  font-family: inherit;

  transition: all 0.4s;

  input:active + & {
    color: ${props => props.theme.colors.color2d3238};
    background: ${props => props.theme.colors.colorddee1e7};
  }

  input:disabled + & {
    color: ${props => props.theme.colors.colorc4c4c4};
    background: ${props => props.theme.colors.colore9ecf3};
    cursor: not-allowed;
  }

  input:checked + & {
    color: ${props => props.theme.colors.color1f6ecd};
    font-weight: 500;
    background: ${({ theme }) => theme.zds.colors.neutral1000};
    border: 1px solid ${props => props.theme.colors.color1f6ecd};
  }
`
